module.exports = __webpack_public_path__ + "img/yellow_point.21f5cb41.png";